import { getAssetPath } from '@/utils';
import { parseYouTubeVideoId } from '@/utils/youtube';

export interface ActivityConfig {
  id: string;
  route: string;
  titleKey: string;
  descriptionKeys: string[];
  icon: string;
  cardImage?: string;
  galleryImages: string[];
  youtubeVideoIds: string[];
}

// Gallery photos are managed exclusively by the admin CMS and loaded via the content
// API (see services/contentApi.ts). There are intentionally no bundled fallbacks.
function videoIds(...urlsOrIds: string[]): string[] {
  return urlsOrIds.map(parseYouTubeVideoId);
}

export const ACTIVITIES: Record<string, ActivityConfig> = {
  'budding-minds': {
    id: 'budding-minds',
    route: '/budding-minds',
    titleKey: 'buddingMinds',
    descriptionKeys: ['buddingMindsDesc'],
    icon: '🌱',
    galleryImages: [],
    youtubeVideoIds: videoIds('64Oc4hiW2w4'),
  },
  'youth-leap': {
    id: 'youth-leap',
    route: '/youth-leap',
    titleKey: 'youthLeap',
    descriptionKeys: ['youthLeapDesc'],
    icon: '🚀',
    galleryImages: [],
    youtubeVideoIds: [],
  },
  environment: {
    id: 'environment',
    route: '/environment',
    titleKey: 'supportSustainability',
    descriptionKeys: ['supportSustainabilityDesc'],
    icon: '🌱',
    cardImage: getAssetPath('assets/sustainability.jpg'),
    galleryImages: [],
    youtubeVideoIds: videoIds('tq9EhErOHV8', '4mqkdrrKg24', 'e1sQtb8Tzl8'),
  },
  'vulnerable-women-families': {
    id: 'vulnerable-women-families',
    route: '/vulnerable-women-families',
    titleKey: 'vulnerableWomenFamilies',
    descriptionKeys: ['vulnerableWomenFamiliesDesc'],
    icon: '💪',
    galleryImages: [],
    youtubeVideoIds: videoIds('tpuWRsGAP-w', 'D1Sh-Mk5Fhg', 'UmdeXyAPuxc', '2Ch22dtWxyE'),
  },
  'old-age-care': {
    id: 'old-age-care',
    route: '/old-age-care',
    titleKey: 'oldAgeCare',
    descriptionKeys: ['oldAgeCareDesc'],
    icon: '❤️',
    galleryImages: [],
    youtubeVideoIds: videoIds('LJ3Urqrimq8'),
  },
  annathanam: {
    id: 'annathanam',
    route: '/annathanam',
    titleKey: 'annathanam',
    descriptionKeys: [
      'annathanamQuote',
      'annathanamDesc1',
      'annathanamDesc2',
      'annathanamQuote2',
      'annathanamDesc3',
      'annathanamDesc4',
    ],
    icon: '🍲',
    cardImage: getAssetPath('assets/annathanam.jpg'),
    galleryImages: [],
    youtubeVideoIds: videoIds('RS6JIZQWKGI'),
  },
};

/** Order used for Primary Activities cards on the home page */
export const MISSION_ACTIVITY_IDS = [
  'budding-minds',
  'youth-leap',
  'vulnerable-women-families',
  'old-age-care',
  'environment',
  'annathanam',
] as const;

export function getActivity(id: string): ActivityConfig | undefined {
  return ACTIVITIES[id];
}

export { parseYouTubeVideoId };
